"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButton = exports.Animation = exports.Container = void 0;

var _styledTools = require("styled-tools");

var _framerMotion = require("framer-motion");

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

var _IconButton = require("../IconButton");

const Container = _stylitas.styled.div`
  width: 100vw;
  height: 100%;
  background-color: ${(0, _styledTools.theme)('colorBackgroundWhite')};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  ${_styleUtilities.media.md`
    width: 576px;
  `}
`;
exports.Container = Container;
const Animation = (0, _stylitas.styled)(_framerMotion.motion.div)`
  height: 100%;
`;
exports.Animation = Animation;
const StyledIconButton = (0, _stylitas.styled)(_IconButton.IconButton)`
  align-self: flex-end;
`;
exports.IconButton = StyledIconButton;